import { motion } from "framer-motion";
import { Reveal, staggerContainer, staggerItem } from "./Reveal";
import { LEADERSHIP } from "../data/site";

export const Leadership = () => {
  return (
    <section id="leadership" data-testid="leadership-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-blue-600">
            Leadership
          </span>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-zinc-900">
            The people behind Inceptica
          </h2>
          <p className="mt-4 text-base text-zinc-600 leading-relaxed">
            A team combining product strategy, engineering, security, compliance and
            customer success to build solutions customers love.
          </p>
        </Reveal>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid md:grid-cols-3 gap-6"
        >
          {LEADERSHIP.map((p) => (
            <motion.div
              key={p.id}
              variants={staggerItem}
              whileHover={{ y: -4 }}
              data-testid={`leader-card-${p.id}`}
              className="group relative overflow-hidden rounded-2xl border border-zinc-200 bg-white p-8 shadow-sm hover:shadow-lg hover:border-zinc-300 transition-shadow"
            >
              <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-blue-100/60 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
              <div className="relative flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-zinc-100 to-white border border-zinc-200 text-xl font-display font-medium tracking-widest text-zinc-900 shadow-sm">
                {p.monogram}
              </div>
              <h3 className="mt-6 font-display text-xl font-medium text-zinc-900">
                {p.name}
              </h3>
              <p className="mt-1 text-sm font-medium text-blue-600">{p.role}</p>
              <p className="mt-4 text-sm text-zinc-600 leading-relaxed">{p.bio}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
